import { gql } from "apollo-boost"

export default gql`
  query ChatRooms {
    chatRooms {
      id
      client {
        id
        name
        company {
          id
          name
        }
      }
      lastMessage {
        type
        content
        createdAt
        sender {
          id
        }
      }
      assistant {
        id
        name
      }
      status
      assistantUnreadCount
    }
  }
`
